<template>
    <div id="app" :style="$store.state.lang == 'ja' ? 'font-family: \'Noto Sans JP\', sans-serif;' : $store.state.lang == 'cn' ? 'font-family: \'Noto Sans SC\', sans-serif;' : 'font-family: \'Open Sans\', sans-serif;'">
        <router-view />
    </div>
</template>

<script>
import Vue from 'vue'
import Meta from 'vue-meta'
Vue.use(Meta)

export default {
    name: "App",
    metaInfo: {
        title: location.host.indexOf('enuma.cn') > -1 ? "埃努码中文" : "Todo Math",
    },
    created() {
        if (this.$route.query.appurl != undefined) {
            this.$store.commit('setCnDownloadUrl', this.$route.query.appurl)
            this.$store.commit('setStoreLang', 'cn')
        } else {
            this.$store.commit('setCnDownloadUrl', this.$store.state.cnStaticDownloadUrl)
        }

        if (this.$route.query.appver != undefined) {
            this.$store.commit('setAppVersion', this.$route.query.appver)
        }

        if (this.$route.query.l == 'cn' || location.host.indexOf('enuma.cn') > -1) {
            this.$store.commit('setStoreLang', 'cn')
        }


    }
};
</script>

<style>
body {
    margin: 0;
}
* {
    box-sizing: border-box;
	word-break: keep-all;
}
#app {
    /* font-family: 'Open Sans', sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    color: #2c3e50;
}
.content-wrap {
    display: block;
    position: relative;
    min-width: 100%;
}
.mobile .content-wrap {
    width: 720px;
}
.laptop .content-wrap {
    width: 1024px;
}
.wide .content-wrap {
    width: 1334px;
}

.menu-bar {
    position: absolute;
    width: 100%;
}

p {
    margin: 0;
}
a {
    text-decoration: none;
}
a:visited,
a:link {
    text-decoration: none;
    color: inherit;
}
pre {
    /* font-family: 'Open Sans', sans-serif; */
}
button {
    /* font-family: 'Open Sans', sans-serif; */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
textarea {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

</style>



// WEBPACK FOOTER //
// src/App.vue